import { pushState, replaceState } from '@utils/history.js'
import http from '@utils/http.js'

let abortController = null
let lastData = null

const guideForm = document.getElementById('guide-form')
guideForm.addEventListener('submit', function (e) {
    e.preventDefault()

    const formData = new FormData(this)
    const serializedData = new URLSearchParams(formData).toString()
    console.log(serializedData)
    if (serializedData === lastData) {
        return
    }
    lastData = serializedData

    if (abortController) {
        abortController.abort()
    }

    abortController = new AbortController()

    document.getElementById('guide-result').classList.add('background--loading')
    http.get(this.action + '?' + serializedData, {
        signal: abortController?.signal,
    })
        .then(function (response) {
            document.getElementById('guide-result').innerHTML = response.data
            document.getElementById('guide-result').classList.remove('background--loading')
            const title = document.getElementById('result-title').value
            if (title != null && title != '') {
                document.querySelector('#guide-container h1').textContent = title
                document.title = title
            }
            const newUrl = document.getElementById('result-url').value
            console.log(newUrl)
            if (newUrl) {
                pushState(
                    {
                        guidesUrl: newUrl,
                    },
                    document.title,
                    newUrl,
                    true,
                )
            }
        })
        .catch(function (error) {
            console.error(error)
        })
})

if (window.history) {
    window.addEventListener('popstate', function (e) {
        if (e.state && e.state.guidesUrl) {
            window.location.href = e.state.guidesUrl
        }
    })
    replaceState({ guidesUrl: window.location.href }, document.title, window.location.href, false)
}

const guideList = document.getElementById('guide-list')
guideList.addEventListener('click', function (e) {
    if (e.target.matches('.sorter')) {
        e.preventDefault()
        guideForm.querySelector('input[name=page]').value = 1
        e.target.parentNode.classList.add('active')
        e.target.parentNode.parentNode.querySelectorAll('.active').forEach(function (el) {
            if (el !== e.target.parentNode) {
                el.classList.remove('active')
            }
        })
        guideForm.querySelector('input[name=sort]').value = e.target.dataset.sort
        guideForm.dispatchEvent(new Event('submit'))
        return false
    }
})

guideList.addEventListener('click', function (e) {
    if (e.target.matches('.pager')) {
        e.preventDefault()
        guideForm.querySelector('input[name=page]').value = e.target.dataset.page
        guideForm.dispatchEvent(new Event('submit'))
        return false
    }
})

guideList.querySelector('select[name=category]').addEventListener('change', function (e) {
    e.preventDefault()
    guideForm.querySelector('input[name=page]').value = 1
    guideForm.dispatchEvent(new Event('submit'))
    return false
})

let autocompleteTimeout = null
let autocompleteLast = null

guideList.querySelector('input[name=q]').addEventListener('keyup', function () {
    guideForm.querySelector('input[name=page]').value = 1
    if (autocompleteLast === this.value) {
        return
    }
    autocompleteLast = this.value
    if (autocompleteTimeout) {
        window.clearTimeout(autocompleteTimeout)
        autocompleteTimeout = null
    }
    autocompleteTimeout = window.setTimeout(function () {
        guideForm.dispatchEvent(new Event('submit'))
    }, 300)
})
